var map = {
	"./carrello/carrello.module.ngfactory": [
		"yHiY",
		0,
		7
	],
	"./clienti/clienti.module.ngfactory": [
		"r+Ed",
		0,
		8
	],
	"./dashboard/dashboard.module.ngfactory": [
		"mhqm",
		0,
		9
	],
	"./giacenze/giacenze.module.ngfactory": [
		"6svA",
		0,
		5
	],
	"./login/login.module.ngfactory": [
		"f+ep",
		0,
		6
	],
	"./movimenti/movimenti.module.ngfactory": [
		"jim+",
		0,
		10
	],
	"./ordini/ordini.module.ngfactory": [
		"PTdM",
		0,
		11
	],
	"./pages/pages.module.ngfactory": [
		"tePd",
		0,
		12
	],
	"./preferenze/preferenze.module.ngfactory": [
		"oFKq",
		13
	],
	"./utenti/utenti.module.ngfactory": [
		"jmE0",
		0,
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;